import { useEffect, useState } from "react";

import { useLocation, Navigate, Outlet } from "react-router-dom";
import Sidenav from "examples/Sidenav";
import { useAuth } from "../context/index";
import { customerAccountVerifiedAt } from "../utils";

// Images
import brandWhite from "assets/images/icons/catering-icons/cr-logo-white.png";
import brandDark from "assets/images/logo-ct-dark.png";

const PrivateRoutes = () => {
  const { sidenavColor, transparentSidenav, whiteSidenav, darkMode, auth, verifiedCustomer } =
    useAuth();

  const [isVerified, setIsVerified] = useState(undefined);
  const location = useLocation();

  useEffect(() => {
    if (!!verifiedCustomer) {
      const accountVerifiedAt = customerAccountVerifiedAt(verifiedCustomer);
      setIsVerified(accountVerifiedAt);
    }
  }, [verifiedCustomer]);

  if (!auth) return <Navigate to="/authentication/sign-in" state={{ from: location }} replace />;

  return isVerified ? (
    <>
      {!(
        location.pathname === "/authentication/verify-customer" ||
        location.pathname === "/authentication/verify-work-emails"
      ) && (
        <Sidenav
          color={sidenavColor}
          brand={(transparentSidenav && !darkMode) || whiteSidenav ? brandDark : brandWhite}
        />
      )}
      <Outlet />
    </>
  ) : (
    <>{location.pathname === "/authentication/verify-customer" ? <Outlet /> : null}</>
  );
};

export default PrivateRoutes;
